import { Grid, SelectChangeEvent, Typography } from "@mui/material";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useQueryMedia } from "../../../../hooks/useQueryMedia";
import Colors from "../../../../utils/Colors";
import SelectCustom from "../../../shared/select-custom/SelectCustom";
import { optionsSortBy } from "../../student-and-teacher/my-answers/config";
import QuestionAnswersAnswer from "./QuestionAnswersAnswer";
import QuestionAnswersQuestion from "./QuestionAnswersQuestion";

export default function QuestionAnswers() {
  const [sortBy, setSortBy] = useState<string>(String(optionsSortBy[0].id));
  const [questionPosted, setQuestionPosted] = useState<boolean>(false);
  const location = useLocation();
  const { isMobile } = useQueryMedia();

  const handleChangeSelect = (event: SelectChangeEvent) => setSortBy(event.target.value);

  return (
    <Grid container spacing={2} justifyContent="center" alignItems="center" className="question-answers">
      <Grid item xs={12} sm={12} md={11} lg={10} xl={10}>
        <Grid container item justifyContent={isMobile ? "flex-start" : "center"} xs={12}>
          <Typography sx={{ fontSize: "16px" }} color={Colors.WHITE} style={{ marginBottom: "8px" }}>
            Question:
          </Typography>
        </Grid>
        <QuestionAnswersQuestion setQuestionPosted={setQuestionPosted} locationState={location?.state} />
        <Grid container justifyContent="space-between" alignItems="center" textAlign="center" mt={isMobile ? 0 : 2} mb={isMobile ? 0 : 1}>
          <Grid container item xs={isMobile ? 0 : 4}></Grid>
          <Grid container item xs={isMobile ? 6 : 4} justifyContent={isMobile ? "flex-start" : "center"}>
            <Typography sx={{ fontSize: "16px" }} color={Colors.WHITE}>
              Answers:
            </Typography>
          </Grid>
          <Grid container item xs={isMobile ? 6 : 4} justifyContent="flex-end">
            <SelectCustom title="Sort by:" value={sortBy} handleChange={handleChangeSelect} options={optionsSortBy} />
          </Grid>
        </Grid>
        <QuestionAnswersAnswer questionPosted={questionPosted} sortBy={sortBy} />
      </Grid>
    </Grid>
  );
}
